import styles from './App.module.css'
import 'react-toastify/dist/ReactToastify.css'
import cx from 'classnames'
import Router from './router/Router'
import { AdminContextProvider } from './contexts/AdminContext'
import React from 'react'
import { useAuth } from './contexts/AuthContext'

const Backend: React.FC = () => {
    const { role } = useAuth()

    return (
        <div className={cx(styles['zr-main-container'])}>
            {role === 'admin' ? (
                <AdminContextProvider>
                    <Router />
                </AdminContextProvider>
            ) : (
                <Router />
            )}
        </div>
    )
}

export default Backend
